import { useSessionStore } from "./session/session-store";
import { useUserStore } from "./user/user-store";

import { useCartStore } from "./cart/cart-store";
import { useConsultantStore } from "./consultant/consultant-store";
import {
	useAddToCartSliderStore,
	type AddedProductSnapshot
} from "./cart/add-to-cart-slider-store";
import {
	initializeStore,
	initializeStoreFromContext
} from "./initialize-store";
import { usePartyStore } from "./party/party-store";

export {
	initializeStore,
	initializeStoreFromContext,
	useSessionStore,
	useUserStore,
	useCartStore,
	usePartyStore,
	useConsultantStore,
	useAddToCartSliderStore
};

export type { AddedProductSnapshot };

export interface SessionState {
	sessionId: string;
	token: string;
	locale: LocaleState;
}

export type LocaleState = "en-US" | "en-CA";

export type UserState =
	| AnonymousUserState
	| CustomerUserState
	| ConsultantUserState;

export type UserType = "anonymous" | "customer" | "consultant";

export type ConsultantState =
	| ConsultantConnectedState
	| ConsultantNotConnectedState;

export type PartyState = PartyConnectedState | PartyNotConnectedState;

export type CartState = CartConnectedState | CartNotConnectedState;

export interface AnonymousUserState {
	type: "anonymous";
}

export interface CustomerUserState {
	type: "customer";
	loggedIn: true;
	userId: string;
	email: string;
	firstName: string;
	lastName: string;
}

export interface ConsultantUserState {
	type: "consultant";
	loggedIn: true;
	userId: string;
	email: string;
	firstName: string;
	lastName: string;
}

export type PartyConnectedState = {
	status: "connected";
	partyId: string;
	partyUrl: string;
	host: {
		userId: string;
		emailAddress: string;
	};
};
export type PartyNotConnectedState = {
	status: "not-connected";
};

export interface CartConnectedState {
	status: "connected";
	cartId: string;
	entries: CartEntry[];
}

export interface CartEntry {
	quantity: number;
}

export interface CartNotConnectedState {
	status: "not-connected";
}

export interface ConsultantConnectedState {
	status: "connected";
	pwsUrl: string;
	firstName: string;
	lastName: string;
	emailAddress: string;
	phoneNumber: string;
	globalId: string;
	consultantNumber: string;
	image: string;
	address: {
		city: string;
		state: string;
		country: string;
	};
}

export interface ConsultantNotConnectedState {
	status: "not-connected";
}
